import { useRequestState } from "@/hooks";
import {
  Document,
  requestDocumentsByApplicationId,
  useBoundStore,
} from "@/services";
import { useContext, useEffect } from "react";
import { AuthContext } from "@/guards/auth/auth-context";
import { UseRequestAttachmentsDataProps } from "@/pages/requests/types";
import { selectApplicationStore } from "@/services/stores/selectors/applications";

export const useRequestAttachmentsData = ({
  requestId,
  getFilesAsBase64,
  refreshKey,
}: UseRequestAttachmentsDataProps & { refreshKey?: number }) => {
  const { account } = useContext(AuthContext);

  const { activeApplication } = useBoundStore(selectApplicationStore);

  const { isLoading, data, error, setSuccess, setError } = useRequestState<
    Document[]
  >({
    isLoading: true,
  });

  useEffect(() => {
    const controller = new AbortController();

    if (requestId) {
      requestDocumentsByApplicationId({
        email: account?.username ?? "",
        requestId,
        getFilesAsBase64,
      })
        .then(response => {
          setSuccess(response);
        })
        .catch(error => {
          setError(error);
        });
    }

    return () => {
      controller.abort();
    };
  }, [
    account?.username,
    activeApplication,
    getFilesAsBase64,
    requestId,
    setError,
    setSuccess,
    refreshKey,
  ]);

  return {
    isLoading,
    data,
    error,
  };
};
